<template>
  <div :class="{'nav-open': $sidebar.showSidebar}">

    <loading :active.sync="loading"
             :can-cancel="false"
             :is-full-page="true"/>

    <notifications />
    <router-view />
  </div>
</template>

<script>
  import Loading from 'vue-loading-overlay';
  import 'vue-loading-overlay/dist/vue-loading.css';

  export default {
    components: {
      Loading
    },
    data() {
      const loading = this.$store.state.main.loading
      return {
        loading
      }
    },
    created() {
      this.$store.watch(
          (state) => state.main.loading,
          () => {
            this.loading = this.$store.state.main.loading;
          },
          {
            deep: true //add this if u need to watch object properties change etc.
          }
      );
    }

    // when route changes and this component is already rendered,
    // the logic will be slightly different.
    // beforeRouteUpdate (to, from, next) {
    //   this.post = null
    //   getPost(to.params.id, (err, post) => {
    //     this.setData(err, post)
    //     next()
    //   })
    // },


  };
</script>

<style lang="scss">
  .vue-notifyjs.notifications {
    .alert {
      z-index: 10000;
    }

    .list-move {
      transition: transform 0.3s, opacity 0.4s;
    }

    .list-item {
      display: inline-block;
      margin-right: 10px;
    }

    .list-enter-active {
      transition: transform 0.2s ease-in, opacity 0.4s ease-in;
    }

    .list-leave-active {
      transition: transform 1s ease-out, opacity 0.4s ease-out;
    }

    .list-enter {
      opacity: 0;
      transform: scale(1.1);
    }

    .list-leave-to {
      opacity: 0;
      transform: scale(1.2, 0.7);
    }
  }
</style>
